<!--P063-->
<template>
  <div class="div_content">
    <div class="cs_margin_top_sm ui_hierarchy">
      <div class="cs_cursor_pointer ui_txt_hierarchy">要货调价查询</div>
    </div>
    <!--查询栏-->
    <div class="cs_margin_top div_search bg_search cs_padding">
      <div class="cs_title_primary cs_text_default type_info_search">制单日期</div>
      <input v-model="search.startDate" id="startDate" class="cs_input cs_radius_lg edtxt_info_search" placeholder="请输入" readonly>
      <div class="cs_title_primary cs_text_default type_info_search margin_left_44">~</div>
      <input v-model="search.endDate" id="endDate" class="cs_input cs_radius_lg edtxt_info_search margin_left_44" placeholder="请输入" readonly>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">制单人</div>
      <web-select :options="search.staffList"
                  @option-key="updateStaff"
                  v-model="search.staffName"
                  class="cs_input cs_radius_lg edtxt_info_search width_148"></web-select>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">状态</div>
      <web-select :options="search.statusList"
                  @option-key="updateStatus"
                  v-model="search.statusName"
                  class="cs_input cs_radius_lg edtxt_info_search width_148"></web-select>
      <button class="ui_btn_search_yellow btn_search" type="button" @click="btnSearch">查询</button>
      <br>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_top_sm">调价单号</div>
      <input v-model="search.id" class="cs_input cs_radius_lg edtxt_info_search cs_margin_top_sm" placeholder="请输入">
      <div class="cs_title_primary cs_text_default cs_margin_top_sm type_info_search cs_margin_left">配送中心</div>
      <web-select :options="search.dcList"
                  @option-key="updateDc"
                  v-model="search.dcName"
                  class="cs_input cs_radius_lg cs_margin_top_sm edtxt_info_search"></web-select>
      <div class="cs_title_primary cs_text_default cs_margin_top_sm type_info_search cs_margin_left">门店</div>
      <search-select :options="search.shopSearchItems"
                     @option-key="updateShopName"
                     v-model="search.shopName"
                     :search-fn="acquireShopItem"
                     class="cs_input cs_radius_lg edtxt_info_search cs_margin_top_sm width_364 ui_margin_left_30"></search-select>
      <br>
      <div class="cs_title_primary cs_text_default cs_margin_top_sm type_info_search">货品</div>
      <search-select :options="search.materialSearchItems"
                     @option-key="updateMaterialName"
                     v-model="search.materialName"
                     :search-fn="acquireMaterialItem"
                     class="cs_input cs_radius_lg cs_margin_top_sm edtxt_info_search width_280 ui_margin_left_44"></search-select>
    </div>
    <!--表格-->
    <div class="cs_margin_top div_search_result cs_padding_top_lg">
      <div class="div_table">
        <table class="cs_table cs_td_divider_none" width="100%">
          <thead>
          <tr>
            <th width="40px">序号</th>
            <th width="114px">调价单号</th>
            <th width="270px">配送中心</th>
            <th width="146px">生效时间</th>
            <th width="74px">状态</th>
            <th width="96px">制单日期</th>
            <th width="63px">制单人</th>
            <th width="264px">备注</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in orderList">
            <td>{{index+1}}</td>
            <td><a @click.stop="$router.push({name:'RequirePriceDetail', query: {id:item.num}})">{{item.num}}</a></td>
            <td>{{item.dcName}}</td>
            <td>{{item.cstEffect}}</td>
            <td>{{PRICE_MANAGE_STATUS[item.orderStatus]}}</td>
            <td>{{timeToDate(item.cstCreate)}}</td>
            <td>{{item.staffName}}</td>
            <td>{{item.remarks}}</td>
          </tr>
          <tr v-for="(item,index) in (PAGE_SIZE-orderList.length)">
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="div_page_download">
        <!--上一页-->
        <button v-show="search.pagination>1" @click="showList(search.pagination < 2?1:search.pagination-1)"
                class="btn_page_up" type="button">
        </button>
        <button v-show="search.pagination<=1" class="btn_page_up_disable" type="button"></button>
        <div class="current_page">{{search.pagination}}</div>
        <div class="oblique_line">/</div>
        <div class="total_page">{{search.totalPage}}</div>
        <!--下一页-->
        <button v-show="search.pagination!==search.totalPage" @click="showList(search.pagination+1)" class="btn_page_down" type="button"></button>
        <button v-show="search.pagination===search.totalPage" class="btn_page_down_disable" type="button"></button>
        <div @click="jump()" class="type_page_jump">跳转至</div>
        <input v-model="search.pageJump" class="txt_page_jump" type="text"
               @keyup="checkPositiveInt($event)" @blur="search.pageJump=checkPositiveInt($event)">
      </div>
    </div>
    <div class="div_bottom"></div>
  </div>
</template>

<script>
  import WebSelect from "../../components/web-select"
  import SearchSelect from "../../components/search-select";
  import {Page, PAGE_SIZE,PRICE_MANAGE_STATUS} from "../../assets/utils/constants"
  import StorageConst from "../../assets/utils/StorageConst";
  import WhParameter from "../../assets/csui/parameter/WhParameter"
  export default {
    name: "RequirePriceManage",
    components: {SearchSelect, WebSelect},
    data: function () {
      return {
        search: {
          startDate: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.REQUIRE_PRICE_MANAGE,"startDate", this.getPreNDays(7)),
          endDate: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.REQUIRE_PRICE_MANAGE,"endDate", this.getNowDate()),
          id: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.REQUIRE_PRICE_MANAGE,"id", ""),
          staffList: [],
          staffId: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.REQUIRE_PRICE_MANAGE,"staffId", 0),
          staffName: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.REQUIRE_PRICE_MANAGE,"staffName", ""),
          statusList: PRICE_MANAGE_STATUS,
          statusId: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.REQUIRE_PRICE_MANAGE,"statusId", 0),
          statusName: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.REQUIRE_PRICE_MANAGE,"statusName", ""),
          materialId: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.REQUIRE_PRICE_MANAGE,"materialId", 0),
          materialName: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.REQUIRE_PRICE_MANAGE,"materialName", ""),
          materialSearchItems: [],
          dcId: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.REQUIRE_PRICE_MANAGE,"dcId", 0),
          dcName: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.REQUIRE_PRICE_MANAGE,"dcName", ""),
          dcList: [],
          shopId: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.REQUIRE_PRICE_MANAGE,"shopId", 0),
          shopName: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.REQUIRE_PRICE_MANAGE,"shopName", ""),
          shopSearchItems: [],
          pageJump: "",
          totalPage: "",
          pagination: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.REQUIRE_PRICE_MANAGE,"pagination", 1)
        },
        orderList: [],
        PAGE_SIZE: PAGE_SIZE,
        PRICE_MANAGE_STATUS: PRICE_MANAGE_STATUS
      }
    },
    created: function () {
      this.showStaff();
      this.showDc();
      this.showList(this.search.pagination);
    },
    mounted: function () {
      const that = this;
      laydate.render({
        elem: '#startDate',
        btns:["now","confirm"],
        done(value) {
          that.search.startDate = value;
        },
      });
      laydate.render({
        elem: '#endDate',
        btns:["now","confirm"],
        done(value) {
          that.search.endDate = value;
        },
      });
    },
    methods:{
      showList(pagination) {
        try {
          let next3Date = this.getNextNMonthDate(this.search.startDate,12);
          WhParameter.verifyStartEndDate(this.search.startDate, "起始时间",this.search.endDate,"截止时间");
          WhParameter.verifyStartEndDate(this.search.endDate, "时间间隔",next3Date,"一年");
        }catch (e) {
          this.$toast(e.message);
          return;
        }
        this.$ajax.priceManage.listRequirePriceManage.bind(this)(this.search, new Page(PAGE_SIZE, pagination), (data) => {
          //显示列表
          this.search.totalPage = data.data.totalPage;
          this.search.pagination = data.data.pagination;
          this.orderList = data.data.list;
          this.setStoreItem(StorageConst.LOCAL_PAGE_LIST.REQUIRE_PRICE_MANAGE, JSON.stringify(this.search));
        }, (data) => {
        }, true)
      },
      btnSearch(){
        this.showList(1);
      },
      jump() {
        if (!this.isEmpty(this.search.pageJump)) {
          if(this.search.pageJump>this.search.totalPage){
            this.showList(this.search.totalPage);
          }else {
            this.showList(this.search.pageJump);
          }
        }
      },
      failDefault() {

      },
      showStaff(){
        this.$ajax.common.listStaff.bind(this)((data) => {
          //显示列表
          let array = [];
          for (let i = 0; i < data.data.length; i++) {
            array.push({
              key: data.data[i].id,
              value: data.data[i].name,
            })
          }
          this.search.staffList = array;
        }, (data) => {
        }, true)
      },
      updateStaff(key) {
        this.search.staffId = key;
      },
      showDc(){
        this.$ajax.common.listDistributionCenter.bind(this)((data) => {
          //显示列表
          let array = [];
          for (let i = 0; i < data.data.length; i++) {
            array.push({
              key: data.data[i].id,
              value: data.data[i].dcName,
            })
          }
          this.search.dcList = array;
        }, (data) => {
        }, true)
      },
      updateDc(key) {
        this.search.dcId = key;
      },
      updateStatus(key) {
        this.search.statusId = key;
      },
      acquireMaterialItem(search) {
        this.$ajax.common.searchMaterial.bind(this)(search,(data) => {
          let array = [];
          for (let i = 0; i < data.data.length; i++) {
            array.push({
              key: data.data[i].id,
              value: data.data[i].materialNum + "  " + data.data[i].materialName,
            })
          }
          this.search.materialSearchItems = array;
        }, this.failDefault, false);
      },
      updateMaterialName(key) {
        this.search.materialId = key;
        if(this.isEmpty(key)){
          this.search.materialName = "";
          this.search.materialId = 0;
        }
      },
      acquireShopItem(search) {
        this.$ajax.common.searchShop.bind(this)(search, (data) => {
          let array = [];
          for (let i = 0; i < data.data.length; i++) {
            array.push({
              key: data.data[i].id,
              value: data.data[i].shopNum + "  " + data.data[i].shopName,
            })
          }
          this.search.shopSearchItems = array;
        }, this.failDefault, false);
      },
      updateShopName(key) {
        this.search.shopId = key;
        if(this.isEmpty(key)){
          this.search.shopName = "";
          this.search.shopId = 0;
        }
      },

      timeToDate(time){
        return this.isEmpty(time)?"":time.substring(0,10)
      },
    }
  }
</script>

<style scoped>
  .width_364{width: 364px;}
  .width_280{width: 280px;}
  .width_148{width: 148px;}
  .margin_left_44{margin-left: 44px;}
</style>



// WEBPACK FOOTER //
// src/page/price/RequirePriceManage.vue